/**
 * A paginação por número: ‹ 1 2 3 4 … 20 ›.
 *
 * Para lista que se percorre aos pedaços e em que a pessoa quer saber quanto
 * falta (os preços da clínica, #1085). Lista que só cresce para baixo usa o
 * "carregar mais" do cursor, não esta.
 *
 * A página atual é `aria-current="page"`; as setas dizem para onde vão e ficam
 * desabilitadas na ponta, em vez de sumir (sumindo, os números pulariam de
 * lugar debaixo do dedo). Com uma página só, nada aparece.
 */

import type { ReactNode } from 'react';
import { Icone } from '../icones';
import { paginasVisiveis } from './paginas-visiveis';
import './paginacao.css';

export type PaginacaoProps = {
  /** A página atual, a partir de 1. */
  pagina: number;
  totalDePaginas: number;
  aoIr: (pagina: number) => void;
  /** O que se pagina, para o leitor de tela: "Páginas dos preços". */
  rotulo: string;
};

export function Paginacao({ pagina, totalDePaginas, aoIr, rotulo }: PaginacaoProps): ReactNode {
  if (totalDePaginas <= 1) return null;

  return (
    <nav className="paginacao" aria-label={rotulo}>
      <button
        type="button"
        className="paginacao__seta paginacao__seta--anterior"
        aria-label="Página anterior"
        disabled={pagina <= 1}
        onClick={() => aoIr(pagina - 1)}
      >
        <Icone nome="direita" />
      </button>
      {paginasVisiveis(pagina, totalDePaginas).map((posicao, indice) =>
        posicao === 'reticencias' ? (
          <span key={`r${indice}`} className="paginacao__reticencias" aria-hidden="true">
            …
          </span>
        ) : (
          <button
            key={posicao}
            type="button"
            className="paginacao__numero"
            aria-label={`Página ${posicao}`}
            aria-current={posicao === pagina ? 'page' : undefined}
            onClick={() => aoIr(posicao)}
          >
            {posicao}
          </button>
        ),
      )}
      <button
        type="button"
        className="paginacao__seta"
        aria-label="Próxima página"
        disabled={pagina >= totalDePaginas}
        onClick={() => aoIr(pagina + 1)}
      >
        <Icone nome="direita" />
      </button>
    </nav>
  );
}
